import {
	AdvertisementLabel,
	dsaHandler,
	TEMPLATE,
	TemplateStateHandler,
	type AdSlot,
} from '@wikia/ad-engine';
import { Inject, Injectable } from '@wikia/dependency-injection';

@Injectable({ autobind: false })
export class AdvertisementLabelHandler implements TemplateStateHandler {
	constructor(@Inject(TEMPLATE.SLOT) private adSlot: AdSlot) {}

	async onEnter(): Promise<void> {
		const adSlotElement = this.adSlot.getElement();
		if (!adSlotElement) {
			return;
		}
		const advertisementLabel = adSlotElement.querySelector('.advertisement-label');
		if (!dsaHandler.isEnabled() && advertisementLabel) {
			return;
		}

		AdvertisementLabel.clearPlaceholderLabels(this.adSlot);

		const newAdvertisementLabel = new AdvertisementLabel({
			slot: this.adSlot.getSlotName(),
		});
		adSlotElement.appendChild(newAdvertisementLabel.render());
	}
}
